import { render } from "./ArticlesSection.vue?vue&type=template&id=4997713c"
import script from "./ArticlesSection.vue?vue&type=script&lang=js"
export * from "./ArticlesSection.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__